import styled from 'styled-components';

export const BannerGerarBoleto = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(184, 184, 184, 1) 50%,
    rgba(77, 77, 77, 0.4990371148459384) 100%
  );
  z-index: 99999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  box-sizing: border-box;
  @media (max-width: 768px) {
    .gerarBoletoOut {
      height: 100vh;
      overflow: scroll;
    }
  }
`;

export const ContainerGerarBoleto = styled.div`
  width: 800px;
  background-color: #ffffff;
  z-index: 999999;
  box-shadow: 0px 0px 10px #4d4d4d;
  border-radius: 10px;
  padding: 16px 24px;

  @media (max-width: 768px) {
    width: 95%;
    height: 98vh;
    padding: 16px;
    border-radius: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    .mobile {
      flex-direction: column;
      margin-top: 5px !important;
    }
    .mobile-sections {
      width: 100% !important;
    }
  }
`;

export const BannerTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  border-radius: 10px;
  margin-bottom: 16px;
  h1 {
    font-weight: 900;
    font-size: 20px;
    color: ${(props) => props.color};
    margin: 0;
  }
`;
